var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8472 14.8556L16.4306 12.8766L16.4184 12.8709C16.1892 12.7729 15.939 12.7335 15.6907 12.7564C15.4424 12.7793 15.2037 12.8638 14.9963 13.0022C14.9718 13.0183 14.9484 13.0358 14.9259 13.0547L12.6441 15C11.1984 14.2978 9.70595 12.8166 9.00376 11.3897L10.9519 9.07312C10.9706 9.04968 10.9884 9.02624 11.0053 9.00093C11.1407 8.79403 11.2229 8.55686 11.2445 8.31053C11.2661 8.0642 11.2264 7.81636 11.1291 7.58906V7.57781L9.14438 3.15374C9.0157 2.8568 8.79444 2.60944 8.51362 2.44859C8.2328 2.28774 7.9075 2.22202 7.58626 2.26124C6.31592 2.42841 5.14986 3.05228 4.30588 4.01633C3.4619 4.98039 2.99771 6.2187 3.00001 7.49999C3.00001 14.9437 9.05626 21 16.5 21C17.7813 21.0023 19.0196 20.5381 19.9837 19.6941C20.9477 18.8501 21.5716 17.6841 21.7388 16.4137C21.7781 16.0926 21.7125 15.7674 21.5518 15.4866C21.3911 15.2058 21.144 14.9845 20.8472 14.8556Z",
    fill: "#9CA0A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e4af499fe4a11665e19238108ee22c50.svg";
export { ForwardRef as ReactComponent };